import { render, staticRenderFns } from "./ExpensesByMachineStats.vue?vue&type=template&id=d28b235a&"
import script from "./ExpensesByMachineStats.vue?vue&type=script&lang=js&"
export * from "./ExpensesByMachineStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports